import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, forkJoin, of } from "rxjs";
import { map, catchError } from "rxjs/operators";
import type {
  ActiveSyncResponse,
  SyncProgress,
} from "./sync-progress.interface";

@Injectable({ providedIn: "root" })
export class SyncProgressService {
  constructor(private http: HttpClient) {}

  checkActiveSyncsInBackend(): Observable<{
    googleSyncStateId?: string;
    microsoftSyncStateId?: string;
    calamariSyncStateId?: string;
  }> {
    return forkJoin({
      google: this.http
        .get<ActiveSyncResponse>("/google-sync-state/active")
        .pipe(catchError(() => of(null))),
      microsoft: this.http
        .get<ActiveSyncResponse>("/microsoft-sync-state/active")
        .pipe(catchError(() => of(null))),
      calamari: this.http
        .get<ActiveSyncResponse>("/calamari-sync-state/active")
        .pipe(catchError(() => of(null))),
    }).pipe(
      map(({ google, microsoft, calamari }) => ({
        googleSyncStateId: google?.data?.googleSyncStateId,
        microsoftSyncStateId: microsoft?.data?.microsoftSyncStateId,
        calamariSyncStateId: calamari?.data?.calamariSyncStateId,
      })),
    );
  }

  getSyncProgress(
    syncStateId: string,
    provider: "GOOGLE" | "MICROSOFT" | "CALAMARI",
    summary = false,
  ): Observable<SyncProgress> {
    const baseEndpoint =
      provider === "GOOGLE"
        ? `/google-sync-state/progress/${syncStateId}`
        : provider === "MICROSOFT"
          ? `/microsoft-sync-state/progress/${syncStateId}`
          : `/calamari-sync-state/progress/${syncStateId}`;
    const endpoint = summary ? `${baseEndpoint}?summary=true` : baseEndpoint;
    return this.http.get<SyncProgress>(endpoint);
  }
}
